module.exports = __webpack_public_path__ + "img/l-cb6-011-2.85e68509.gif";